<template>
  <div class="layout-wrapper">
    <aside
      :class="['sidebar', { 'sidebar-hidden': !sidebarVisible }]"
      v-bind="$attrs"
    >
      <div class="heading-left">
        <div class="logo-section">
          <div class="logo-container">
            <div class="logo-icon">
              <img
                src="../../../src/assets/images/Godgreek-Logo.png"
                class="logo-image"
              />
            </div>
            <div class="logo-text">
              <div class="brand-name">GodGreek</div>
            </div>
          </div>
        </div>
        <!-- Back arrow button for small screens -->
        <button
          v-if="sidebarVisible && isSmallScreen"
          class="back-arrow-btn"
          @click="$emit('sidebarcall')"
        >
          <i class="pi pi-arrow-left"></i>
        </button>
      </div>
      <div class="menu">
        <div class="box">
          <router-link
            :to="{ name: 'Dashboard' }"
            class="menu-item"
            :class="{ 'active-link': $route.name === 'Dashboard' }"
          >
            <i class="menu-icon pi pi-th-large"></i>
            Dashboard
            <span class="menu-caret" v-if="$route.name === 'Dashboard'"
              ><i class="pi pi-chevron-right"></i
            ></span>
          </router-link>
        </div>

        <!-- <div class="box">
          <router-link
            :to="{ name: 'GameList' }"
            class="menu-item"
            :class="{ 'active-link': $route.name === 'GameList' || 'GameManagement' }"
          >
            <i class="menu-icon pi pi-list"></i>
            Games List
            <span class="menu-caret" v-if="$route.name === 'GameList' || 'GameManagement'"
              ><i class="pi pi-chevron-right"></i
            ></span>
          </router-link>
        </div> -->

        <!-- <div class="box">
          <router-link
            :to="{ name: 'CategoryList' }"
            class="menu-item"
            :class="{ 'active-link': $route.name === 'CategoryList' }"
          >
            <i class="menu-icon pi pi-discord"></i>
            Category
            <span class="menu-caret" v-if="$route.name === 'CategoryList'"
              ><i class="pi pi-chevron-right"></i
            ></span>
          </router-link>
        </div> -->

        <router-link
          :to="{ name: 'GameBooking' }"
          class="menu-item"
          :class="{ 'active-link': $route.name === 'GameBooking' }"
        >
          <i class="menu-icon pi pi-calendar"></i>
          Games Booking
          <span class="menu-caret" v-if="$route.name === 'GameBooking'"
            ><i class="pi pi-chevron-right"></i
          ></span>
        </router-link>

        <router-link
          :to="{ name: 'PlanBooking' }"
          class="menu-item"
          :class="{ 'active-link': $route.name === 'PlanBooking' }"
        >
          <i class="menu-icon pi pi-ticket"></i>
          Plans Purchased
          <span class="menu-caret" v-if="$route.name === 'PlanBooking'"
            ><i class="pi pi-chevron-right"></i
          ></span>
        </router-link>

        <div class="box">
          <!-- Parent Menu: Master -->
          <div
            class="menu-item"
            @click="toggleMaster"
            :class="{ 'active-link': isMasterActive }"
          >
            <i class="menu-icon pi pi-folder"></i>
            Master
            <span class="menu-caret">
              <i
                :class="
                  masterOpen ? 'pi pi-chevron-down' : 'pi pi-chevron-right'
                "
              ></i>
            </span>
          </div>

          <!-- Child Menus (Show/Hide on Toggle) -->
          <transition name="slide-fade">
            <div v-if="masterOpen" class="submenu">
              <router-link
                :to="{ name: 'SlotManagement' }"
                class="menu-item child"
                :class="{
                  'active-link-child': $route.name === 'SlotManagement',
                }"
              >
                <i class="menu-icon pi pi-clock"></i>
                Slot
              </router-link>
              <router-link
                :to="{ name: 'CategoryList' }"
                class="menu-item child"
                :class="{ 'active-link-child': $route.name === 'CategoryList' }"
              >
                <i class="menu-icon pi pi-tags"></i>
                Category
              </router-link>

              <router-link
                :to="{ name: 'GameList' }"
                class="menu-item child"
                :class="{ 'active-link-child': $route.name === 'GameList' }"
              >
                <i class="menu-icon pi pi-desktop"></i>
                Games
              </router-link>

              <router-link
                :to="{ name: 'MembershipList' }"
                class="menu-item child"
                :class="{
                  'active-link-child': $route.name === 'MembershipList',
                }"
              >
                <i class="menu-icon pi pi-ticket"></i>
                Membership
              </router-link>
            </div>
          </transition>
        </div>

        <!-- <div class="box">
          <router-link
            :to="{ name: 'TicketBooking' }"
            class="menu-item"
            :class="{ 'active-link': $route.name === 'TicketBooking' }"
          >
            <i class="menu-icon pi pi-ticket"></i>
            Ticket Booking
            <span class="menu-caret" v-if="$route.name === 'TicketBooking'"
              ><i class="pi pi-chevron-right"></i
            ></span>
          </router-link>
        </div> -->

        <div class="box">
          <router-link
            :to="{ name: 'ManageMembershipList' }"
            class="menu-item"
            :class="{ 'active-link': $route.name === 'ManageMembershipList' }"
          >
            <i class="menu-icon pi pi-briefcase"></i>
            Manage Membership
            <span
              class="menu-caret"
              v-if="$route.name === 'ManageMembershipList'"
              ><i class="pi pi-chevron-right"></i
            ></span>
          </router-link>
        </div>

        <!-- <div class="box">
          <router-link
            :to="{ name: 'ReportList' }"
            class="menu-item"
            :class="{ 'active-link': $route.name === 'ReportList' }"
          >
            <i class="menu-icon pi pi-file"></i>
            Report
            <span class="menu-caret" v-if="$route.name === 'ReportList'"
              ><i class="pi pi-chevron-right"></i
            ></span>
          </router-link>
        </div> -->
        <div class="box">
          <!-- Parent Menu: Master -->
          <div
            class="menu-item"
            @click="toggleReport"
            :class="{ 'active-link': isReportActive }"
          >
            <i class="menu-icon pi pi-file"></i>
            Report
            <span class="menu-caret">
              <i
                :class="
                  reportOpen ? 'pi pi-chevron-down' : 'pi pi-chevron-right'
                "
              ></i>
            </span>
          </div>

          <!-- Child Menus (Show/Hide on Toggle) -->
          <transition name="slide-fade">
            <div v-if="reportOpen" class="submenu">
              <router-link
                :to="{ name: 'ReportList' }"
                class="menu-item child"
                :class="{ 'active-link-child': $route.name === 'ReportList' }"
              >
                <i class="menu-icon pi pi-desktop"></i>
                Game Report
              </router-link>
              <router-link
                :to="{ name: 'MembershipReport' }"
                class="menu-item child"
                :class="{
                  'active-link-child': $route.name === 'MembershipReport',
                }"
              >
                <i class="menu-icon pi pi-id-card"></i>
                Membership Report
              </router-link>
            </div>
          </transition>
        </div>
        <div class="box">
          <router-link
            :to="{ name: 'RewardList' }"
            class="menu-item"
            :class="{ 'active-link': $route.name === 'RewardList' }"
          >
            <i class="menu-icon pi pi-star"></i>
            Reward
            <span class="menu-caret" v-if="$route.name === 'RewardList'"
              ><i class="pi pi-chevron-right"></i
            ></span>
          </router-link>
        </div>
        <div class="box">
          <router-link
            :to="{ name: 'UserList' }"
            class="menu-item"
            :class="{ 'active-link': $route.name === 'UserList' }"
          >
            <i class="menu-icon pi pi-user"></i>
            User
            <span class="menu-caret" v-if="$route.name === 'UserList'"
              ><i class="pi pi-chevron-right"></i
            ></span>
          </router-link>
        </div>
        <div class="box">
          <router-link
            :to="{ name: 'AdminGameBookingList' }"
            class="menu-item"
            :class="{ 'active-link': $route.name === 'AdminGameBookingList' }"
          >
            <i class="menu-icon pi pi-desktop"></i>
            Booking
            <span
              class="menu-caret"
              v-if="$route.name === 'AdminGameBookingList'"
              ><i class="pi pi-chevron-right"></i
            ></span>
          </router-link>
        </div>

        <div class="box">
          <router-link
            :to="{ name: 'GalleryList' }"
            class="menu-item"
            :class="{ 'active-link': $route.name === 'GalleryList' }"
          >
            <i class="menu-icon pi pi-images"></i>
            Gallery
            <span class="menu-caret" v-if="$route.name === 'GalleryList'"
              ><i class="pi pi-chevron-right"></i
            ></span>
          </router-link>
        </div>
      </div>
    </aside>
  </div>

  <div class="main-content">
    <header class="header">
      <button class="split-button" @click="$emit('sidebarcall')">
        <i class="pi pi-bars"></i>
      </button>
      <div class="content-heading">
        <div class="heading-wrap">
          <div class="heading-title">GodGreek Dashboard</div>
          <!-- <div class="heading-sub">
            Manage your entertainment business efficiently
          </div> -->
        </div>
        <div class="heading-right">
          <div class="location-pill">
            <span v-if="token" class="username mr-2">{{ user }}</span>
            <i v-if="token" class="pi pi-sign-out" @click="logout"></i>
            <div v-else>
              <button @click="login" class="nav-btn login-btn">Login</button>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  props: {
    sidebarVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      user: this.$store.state.userInfo.firstname,
      token: this.$store.state.userToken,
      selectedLocation: null,
      locations: [
        { name: "Location 1", code: "L1" },
        { name: "Location 2", code: "L2" },
        { name: "Location 3", code: "L3" },
      ],
      isSmallScreen: false,
      masterOpen: false,
      reportOpen: false,
    };
  },
  computed: {
    isMasterActive() {
      return (
        this.$route.name === "GameList" || this.$route.name === "CategoryList"
      );
    },
    isReportActive() {
      return (
        this.$route.name === "ReportList" ||
        this.$route.name === "MembershipReport"
      );
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isSmallScreen = window.innerWidth <= 1024;
    },
    toggleMaster() {
      this.masterOpen = !this.masterOpen;
    },
    toggleReport() {
      this.reportOpen = !this.reportOpen;
    },
    login() {
      this.$router.push("/login");
    },
    logout() {
      localStorage.removeItem("userToken");
      this.$store.commit("setUserToken", null);
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-wrapper {
  display: flex;
}

.sidebar {
  width: 15rem;
  background: #ffffff;
  border-right: 1px solid #e5e7eb;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 1000;
  transition: transform 0.3s ease;
  overflow: auto;
}

.sidebar-hidden {
  transform: translateX(-100%);
}

.main-content {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  margin-left: 15rem;
  z-index: 900;
}

.header {
  position: relative;
  left: 0;
  right: 0;
  height: 4.6rem;
  padding: 0 1.5rem;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
}

.back-arrow-btn {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: #374151;
  cursor: pointer;
  margin-left: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: visible;
  opacity: 1;
}

.back-arrow-btn:hover {
  color: #111827;
}

.split-button {
  display: none;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  margin-right: 1rem;
  color: #374151;
}

.split-button:hover {
  color: #111827;
}

@media (max-width: 1024px) {
  .sidebar {
    width: 13rem;
  }

  .main-content {
    margin-left: 0;
  }

  .split-button {
    display: block;
  }
}

@media (max-width: 768px) {
  .sidebar {
    width: 13rem;
  }

  .header {
    padding: 0 1rem;
  }

  .back-arrow-btn {
    font-size: 1.25rem;
    visibility: visible;
    opacity: 1;
  }
}

@media (max-width: 480px) {
  .sidebar {
    width: 13rem;
  }

  .back-arrow-btn {
    font-size: 1rem;
    visibility: visible;
    opacity: 1;
  }
}

.heading-left {
  display: flex;
  height: auto;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e5e7eb;
}

@media (max-width: 1024px) {
  .heading-left {
    padding: 0.75rem;
  }
}

.content-heading {
  z-index: 1001;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: transparent;
}

.heading-title {
  font-size: 1.75rem;
  font-weight: 800;
  background: linear-gradient(
    90deg,
    rgba(186, 0, 0, 1) 0%,
    rgba(179, 0, 0, 1) 25%,
    rgba(89, 0, 0, 1) 98%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.heading-sub {
  font-size: 0.875rem;
  color: #6b7280;
}

.location-pill {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #ffffff;
  padding: 0.5rem 0.75rem;
  color: #111827;
}

.logo-section {
  display: flex;
  align-items: center;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.logo-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
}

.logo-image {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.logo-text {
  display: flex;
  flex-direction: column;
}

.brand-name {
  font-size: 1.25rem;
  font-weight: 700;
  color: black;
  line-height: 1.2;
}

.baricon-nav {
  font-size: 1.5rem;
  color: black;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 2.5rem;
  opacity: 0.9;
}

.baricon-nav:hover {
  opacity: 1;
}

.header-spacer {
  flex: 1;
}

.top-nav {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.nav {
  display: flex;
  align-items: center;
}

.top-menu {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.location-dropdown {
  min-width: 10rem;
}

:deep(.location-dropdown .p-dropdown) {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}

:deep(.location-dropdown .p-dropdown:hover) {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.location-value {
  display: flex;
  align-items: center;
  color: white;
}

.avatar-wrapper {
  display: flex;
  align-items: center;
}

:deep(.p-avatar) {
  width: 2.5rem;
  height: 2.5rem;
  transition: all 0.3s ease;
}

:deep(.p-avatar img) {
  object-fit: cover;
}

.logout-btn {
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 0.875rem;
  font-weight: 500;
}

.logout-btn:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  color: white;
}

#sidebar {
  width: 15rem;
  height: calc(100vh - 4rem);
  background: #ffffff;
  position: fixed;
  overflow-y: auto;
  transition: all 0.3s ease;
  left: 0;
  top: 5.5rem;
  border-right: 1px solid #e5e7eb;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.05);
}

#sidebar::-webkit-scrollbar {
  width: 0.5rem;
}

#sidebar::-webkit-scrollbar-track {
  background: transparent;
}

#sidebar::-webkit-scrollbar-thumb {
  background: transparent;
}

#sidebar:hover::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 0.25rem;
}

.menu {
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1rem;
  gap: 0.25rem;
}

.box {
  margin-bottom: 0.25rem;
}

.menu-item {
  display: flex;
  align-items: center;
  width: 100%;
  height: 2.75rem;
  padding: 0.75rem 1rem;
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  gap: 0.75rem;
  touch-action: manipulation;
  position: relative;
}

.menu-item:hover {
  background-color: #ffe9e9;
  color: #ef4444;
}

.menu-item.active-link {
  background-color: #ffe9e9;
  border: 1px solid #f77979;
  color: #ef4444;
  font-weight: 600;
}

.menu-item.active-link-child {
  color: #ef4444;
  font-weight: 600;
}

.menu-item .menu-icon {
  font-size: 1.125rem;
  color: inherit;
  min-width: 1.125rem;
}

.menu-caret {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.5rem;
  color: #ef4444;
}

:deep(.p-overlaybadge .p-badge) {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  background: #ef4444;
  width: 1.25rem;
  height: 1.25rem;
  color: white;
  font-size: 0.75rem;
  line-height: 1.25rem;
}

@media (max-width: 1024px) {
  .header {
    padding: 0 1rem;
  }

  .logo-image {
    width: 30px;
    height: 30px;
    object-fit: contain;
  }

  .logo-icon {
    width: 2rem;
    height: 2rem;
  }

  .baricon-nav {
    font-size: 1.25rem;
  }

  .location-dropdown {
    max-width: 15rem;
  }

  :deep(.p-avatar) {
    width: 2rem;
    height: 2rem;
  }

  #sidebar {
    width: 12rem;
    height: calc(100vh - 3.5rem);
    top: 3.5rem;
    position: absolute;
    z-index: 1;
  }

  .content-heading {
    left: 12rem;
    top: 3.5rem;
    padding: 0.75rem 0.5rem;
  }

  #sidebar::-webkit-scrollbar {
    width: 0.4rem;
  }

  .menu-item {
    height: 2.25rem;
    padding: 0.375rem 0.75rem;
    font-size: 0.75rem;
  }

  .menu-item .menu-icon {
    font-size: 1rem;
  }
  .menu-item.active-link {
    height: auto;
  }
}

@media (max-width: 768px) {
  .header {
    padding: 0 0.75rem;
  }

  .logo-icon {
    width: 30px;
    height: 30px;
  }

  .logo-image {
    width: 30px;
    height: 30px;
    object-fit: contain;
  }

  .menu-item.active-link {
    height: auto;
  }

  .baricon-nav {
    font-size: 1.25rem;
  }

  .location-dropdown {
    max-width: 12rem;
  }

  .top-menu {
    gap: 0.5rem;
  }

  :deep(.p-avatar) {
    width: 1.75rem;
    height: 1.75rem;
  }

  #sidebar {
    width: 10rem;
    height: calc(100vh - 3rem);
    top: 3rem;
    position: absolute;
    z-index: 1;
  }

  .content-heading {
    left: 10rem;
    top: 3rem;
  }

  #sidebar::-webkit-scrollbar {
    width: 0.3rem;
  }

  .menu-item {
    height: 2rem;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
  }

  .menu-item .menu-icon {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .header {
    padding: 0 0.5rem;
  }

  .logo-icon {
    width: 30px;
    height: 30px;
  }

  .logo-image {
    width: 30px;
    height: 30px;
    object-fit: contain;
  }

  .menu-item.active-link {
    height: auto;
  }

  .baricon-nav {
    font-size: 1rem;
  }

  .location-dropdown {
    max-width: 8rem;
  }

  .top-nav {
    gap: 0.5rem;
  }

  :deep(.p-avatar) {
    width: 1.5rem;
    height: 1.5rem;
  }

  #sidebar {
    width: 8rem;
    height: calc(100vh - 3rem);
    top: 3rem;
    position: absolute;
    z-index: 1;
  }

  .content-heading {
    left: 8rem;
    top: 3rem;
  }

  #sidebar::-webkit-scrollbar {
    width: 0.2rem;
  }

  .menu-item {
    height: 1.75rem;
    padding: 0.125rem 0.25rem;
    font-size: 0.875rem;
  }

  .menu-item .menu-icon {
    font-size: 1rem;
  }
}
.submenu {
  display: flex;
  flex-direction: column;
  padding-left: 1.5rem; // indent children
}

.menu-item.child {
  font-size: 0.8rem;
  height: 2.25rem;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
</style>
